import { Database } from './../database';
import { Injectable } from "@angular/core";

import 'rxjs/add/operator/map';
import { Nl_MalKabul } from '../../models/NL_MalKabul';

@Injectable()
export class BLLMalKabul extends Database{
    eklenecek_birimler=[];

    constructor(){
        super("NL_MalKabul");
    }
    MiktariGuncelle(kalemdetay: Nl_MalKabul) {
        return new Promise((res, err) => {
          this.execRawQueryWithParams("update NL_MalKabul set STHAR_GCMIK = ? where INCKEYNO = ?", [kalemdetay.STHAR_GCMIK, kalemdetay.INCKEYNO]).then(a => {
            res(a);
          });
      
    
        })
      }
}


// WEBPACK FOOTER //
// ./src/providers/bll/bll-nlsiparis.ts